var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("zx" + (_vm.item.eType)),{tag:"component",attrs:{"item":_vm.item,"form-data":_vm.formData},on:{"event":_vm.event}})}
var staticRenderFns = []

export { render, staticRenderFns }